import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, SimpleChanges} from '@angular/core';

import * as _ from 'lodash';
import * as moment from 'moment';

import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/cpg/services/coupons.service';

@Component({
  selector: 'app-create-coupon-select-retailers',
  templateUrl: './create-coupon-select-retailers.component.html',
  styleUrls: ['./create-coupon-select-retailers.component.scss']
})
export class CreateCouponSelectRetailersComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER) - Used only for CPG
  @Output() navigation = new EventEmitter(); // Navigation click event

  public loginData: any;
  public couponData: any;

  public retailersFull: any = [];
  public retailers: any = [];
  public retailersLoading: boolean = false;

  public retailersSelected: any = [];

  constructor(
    private _utilService: UtilService,
    private _couponsService: CouponsService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('C_LOGIN');
    this.couponData = await this._utilService.getStorageData('C_NEW_COUPON');

    // Set retailers already selected
    this.retailersSelected = [];
    if (this.couponData) {
      if(this.couponData.retailers) {
        this.retailersSelected = this.couponData.retailers;
      }
    }

    this.getRetailers();
  }

  // Get retailers and stores
  getRetailers() {
    this.retailersFull = [];
    this.retailers = [];
    this.retailersLoading = true;

    // Get selected products in step 1
    let selectedProducts: any = [];
    if (this.couponData) {
      selectedProducts = this.couponData.products;
    }

    // Get retailer list
    let getRetailersBody = {
      provider_type: this.loginData.user_details.provider_type,
      provider_id: this.loginData.user_details.provider_id,
      products: selectedProducts
    };

    this._couponsService.getRetailers(this.loginData.token, getRetailersBody).subscribe(async getRetailersResponse => {
      this.retailersLoading = false;

      if (getRetailersResponse.status === true) { // Success
        this.retailersFull = getRetailersResponse.retailers;
        this.retailers = _.uniqBy(getRetailersResponse.retailers, 'retailer_id'); // Remove duplicates
      } else {
        this._utilService.showToast(getRetailersResponse.message, '', 'error', {});
      }
    }, error => { // Error from getRetailers
      this.retailersLoading = false;
    });
  }

  // Check if retailer is selected
  isRetailerSelected(retailer: any) {
    let tempRetailersSelected: any = this.retailersSelected;

    tempRetailersSelected = _.filter(tempRetailersSelected, obj => obj.retailer_id == retailer.retailer_id);

    if (tempRetailersSelected.length == 0) { // Not selected
      return false;
    } else { // Selected
      return true;
    }
  }

  // On retailer select/remove
  onRetailerClick(item: any, event: any) {
    let tempRetailersSelected: any = this.retailersSelected;

    if (event.target.checked) { // Add retailer
      let selectedRetailerDetails : any = {
        retailer_id: item.retailer_id,
        retailer_name: item.retailer_name,
        logo: item.logo,
        stores: []
      };
      // Get retailer stores
      let tempStores = _.filter(this.retailersFull, obj => obj.retailer_id == item.retailer_id);

      for (let i=0; i  <= tempStores.length - 1; i++) {
        selectedRetailerDetails.stores.push({
          status:  true, // Select by default
          store_id:  tempStores[i].store_id,
          store_name: tempStores[i].store_name,
          date_range: [new Date(moment.utc().format('YYYY-MM-DD')), new Date(moment.utc().add(30, 'days').format('YYYY-MM-DD'))],
          max_redeem_quantity: 1, // Default
          max_redemptions: 0, // Default
        });
      }

      tempRetailersSelected.push(selectedRetailerDetails);
      tempRetailersSelected = _.uniqBy(tempRetailersSelected, 'retailer_id'); // Remove duplicate if any
    } else { // Remove retailer
      tempRetailersSelected = _.filter(tempRetailersSelected, obj => obj.retailer_id !== item.retailer_id);
    }

    this.retailersSelected = tempRetailersSelected; // Add to selected list
  }

  // On navigation click
  async onNavigationClick(action: string) {
    if (action == 'previous') {
      // Save coupon data in storage
      this.couponData.retailers = this.retailersSelected;
      let responseSetStorageDataC_NEW_COUPON = await this._utilService.setStorageData('C_NEW_COUPON', this.couponData);

      this.navigation.emit({ step: 3, button: action, status : true });
    } else  {
      if (this.retailersSelected.length == 0) { // Retailers not selected
        this._utilService.showToast('Please select retailers', '', 'warning', {});
      } else { // Add selected retailers to storage
        this.couponData.retailers = this.retailersSelected;

        let responseSetStorageDataC_NEW_COUPON = await this._utilService.setStorageData('C_NEW_COUPON', this.couponData);

        this.navigation.emit({ step: 3, button: action, status : true });
      }
    }
  }

}
